import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
const testimonials = [{
  id: 1,
  text: 'Estudié toda la semana con el método del Tomo 2 y por primera vez en mi carrera sentí que lo que estudiaba se me quedaba de verdad. Aprobé con 8.',
  author: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Estudiante de Psicología'
}, {
  id: 2,
  text: 'Llegué al parcial con 48 horas de anticipación y usé la guía de emergencia. No solo aprobé, saqué un 7. Nunca pensé que era posible.',
  author: 'Matías R.',
  location: 'Rosario',
  role: 'Estudiante de Ingeniería'
}, {
  id: 3,
  text: 'Siempre me bloqueaba en el momento del examen aunque supiera el tema. El protocolo del Tomo 5 me cambió todo. Entré al aula de otra manera.',
  author: 'Valentina C.',
  location: 'Córdoba',
  role: 'Estudiante de Derecho'
}, {
  id: 4,
  text: 'Reprobé en junio y casi abandono la carrera. El Tomo 7 me ayudó a levantarme y encarar el recuperatorio con un plan real. Aprobé con 6.',
  author: 'Lucas M.',
  location: 'Mendoza',
  role: 'Estudiante de Administración'
}, {
  id: 5,
  text: 'Nunca había podido dormir bien antes de un parcial. Las técnicas del Tomo 3 me cambiaron la rutina de noche por completo. Aprobé tranquila.',
  author: 'Camila T.',
  location: 'La Plata',
  role: 'Estudiante de Medicina'
}, {
  id: 6,
  text: 'Nunca pensé que iba a encontrar algo así. Terminé la carrera hace poco y ojalá hubiera tenido Aprobá en serio desde primer año. Me hubiera ahorrado años de estrés.',
  author: 'Sofía V.',
  location: 'Buenos Aires',
  role: 'Abogada recibida'
}, {
  id: 7,
  text: 'Llegué sin saber nada de cómo organizarme y en una semana ya tenía todo claro. Las técnicas del Tomo 2 me salvaron el parcial de estructuras.',
  author: 'Brandon I.',
  location: 'Córdoba',
  role: 'Estudiante de Arquitectura'
}, {
  id: 8,
  text: 'Pensé que estudiar era solo leer y releer. Aprobá en serio me mostró que estaba perdiendo horas sin resultado. Cambié todo en una semana.',
  author: 'Jeremías L.',
  location: 'Rosario',
  role: 'Estudiante universitario'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-20 px-6 lg:px-8 bg-cream" data-id="element-211">
      <div className="max-w-[1100px] mx-auto" data-id="element-212">
        <SectionHeader data-id="element-213" />
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12" data-id="element-214">
          Lo que dicen los que ya aprobaron
        </h2>

        <div className="relative max-w-4xl mx-auto" data-id="element-215">
          <div className="overflow-hidden relative min-h-[300px] flex items-center justify-center" data-id="element-216">
            <AnimatePresence mode="wait" data-id="element-217">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-border w-full text-center relative" data-id="element-218">
                <Quote className="absolute top-6 left-6 text-lavender/50" size={48} data-id="element-219" />
                <p className="text-xl md:text-2xl font-medium text-dark mb-8 relative z-10 leading-relaxed" data-id="element-220">
                  "{testimonials[currentIndex].text}"
                </p>
                <div data-id="element-221">
                  <p className="font-bold text-lg" data-id="element-222">
                    {testimonials[currentIndex].author}
                  </p>
                  <p className="text-dark/60 text-sm" data-id="element-223">
                    {testimonials[currentIndex].location} —{' '}
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 bg-white p-3 rounded-full shadow-md hover:bg-gray-50 transition-colors z-20 border border-border" aria-label="Anterior testimonio" data-id="element-224">
            <ChevronLeft size={24} data-id="element-225" />
          </button>

          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 bg-white p-3 rounded-full shadow-md hover:bg-gray-50 transition-colors z-20 border border-border" aria-label="Siguiente testimonio" data-id="element-226">
            <ChevronRight size={24} data-id="element-227" />
          </button>

          <div className="flex justify-center gap-2 mt-8" data-id="element-228">
            {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-3 h-3 rounded-full transition-colors ${idx === currentIndex ? 'bg-salmon' : 'bg-border'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-229" />)}
          </div>
        </div>
      </div>
    </section>;
}